module.exports = __webpack_public_path__ + "img/Flag_of_Oman.c7dcd8eb.svg";